let forbiddenRedirectInProgress = false;
export function handleForbidden(response) {
  if (response.status === 403 || response.status === 401) {
    // SSR/Node safety
    if (typeof window === "undefined") return true;
    const path = window.location.pathname;
    // Prevent redirect loop or multiple redirects
    if (
      !forbiddenRedirectInProgress &&
      path !== "/login" 
    ) {
      forbiddenRedirectInProgress = true;
      window.location.replace("/login");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("userId");
      localStorage.removeItem("userProfile");
    }
    return true;
  }
  return false;
}